import template from './clientProfileVersionEdit.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
controller: class controller {
    constructor($mdDialog, $mdMedia, eventService, ORGANIZATION) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;
      ctrl.wizardSteps = [];

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = function () {
        ctrl.wizardSteps = _.sortBy(
          ORGANIZATION.SETTINGS.CLIENT_PORTAL.CLIENT_PROFILE_WIZARD,
          'id'
        );
        ctrl.destroyWatch = eventService.onDialogClientProfileVersionEdit((params) => {
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {
                id: params.id,
                title: params.title,
                content: params.content,
                wizardSteps: ctrl.wizardSteps
              },
              template,
              controllerAs: '$ctrl',
              controller(id, title, content, wizardSteps) {
                this.id = id;
                this.title = title;
                this.content = content;
                this.wizardSteps = wizardSteps;
                this.availableWizardSteps = [];
                this.selectedWizardSteps = [];

                for (let w = 0; w < this.wizardSteps.length; w++) {
                  const step = this.wizardSteps[w];
                  this.availableWizardSteps.push({
                    id: step.id,
                    name: step.name,
                    isSelected: this.id === 'full' ? true : this.content.indexOf(step.id) > -1
                  });
                }

                this.getStep = function (idStep) {
                  return _.find(this.availableWizardSteps, (s) => s.id === idStep);
                };

                if (this.id === 'full') {
                  this.selectedWizardSteps = this.availableWizardSteps;
                } else {
                  for (let s = 0; s < this.content.length; s++) {
                    const step = this.getStep(this.content[s]);
                    if (step !== undefined) {
                      this.selectedWizardSteps.push(step);
                    }
                  }
                }

                this.toggleWizardSteps = function (step) {
                  const idx = this.isStepSelected(step);
                  if (idx === -1) {
                    this.selectedWizardSteps.push(step);
                  } else {
                    this.selectedWizardSteps.splice(idx, 1);
                  }
                  this.selectedWizardSteps.sort(this.compare);
                };

                this.compare = function (a, b) {
                  if (a.id < b.id) {
                    return -1;
                  }
                  return a.id > b.id ? 1 : 0;
                };

                this.isStepSelected = function (step) {
                  const idx = _.findIndex(this.selectedWizardSteps, (s) => s.id === step.id);
                  return idx;
                };

                this.confirm = function () {
                  this.content = _.map(this.selectedWizardSteps, 'id');
                  $mdDialog.hide(this.content);
                };
                this.cancel = function () {
                  $mdDialog.cancel();
                };
              }
            })
            .then((content) => {
              if (ctrl.onFinished) {
                ctrl.onFinished({ result: { id: params.id, content } });
              }
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
